/* Sour Days storefront (theme v30): cart drawer on the Shopify AJAX cart, product page, pack builder, creator videos, hero video. */
(function () {
  'use strict';
  var SD = window.SD30 || { flavors: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fmt = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var byName = {};
  Object.keys(SD.flavors).forEach(function (h) { byName[SD.flavors[h].name] = SD.flavors[h]; });

  /* ---------------- cart drawer ---------------- */
  var cartlink = $('#cartlink');
  var drawer = $('#drawer');
  function setCount(c) { if (cartlink) cartlink.textContent = 'Cart ' + c.item_count; }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function openDrawer() { document.body.classList.add('drawer-open'); if (drawer) drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); if (drawer) drawer.setAttribute('aria-hidden', 'true'); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function isCustom(it) { return /^sour-days-custom/.test(it.handle || ''); }
  function itemName(it) {
    var f = SD.flavors[it.handle];
    if (f) return f.name + ' · ' + String(it.variant_title || '').toLowerCase();
    if (isCustom(it)) return 'Custom pack · ' + (/12/.test(it.handle) ? 12 : 6) + ' bags';
    return it.product_title + (it.variant_title && !/Default/.test(it.variant_title) ? ' · ' + it.variant_title : '');
  }
  function itemThumb(it) {
    var f = SD.flavors[it.handle];
    if (f) return f.front;
    if (isCustom(it) && it.properties) {
      for (var k in it.properties) if (byName[k] && it.properties[k]) return byName[k].front;
    }
    return it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
  }
  function itemMeta(it) {
    var plan = it.selling_plan_allocation ? 'Monthly · 15% off' : 'One-time';
    if (isCustom(it) && it.properties) {
      var parts = [];
      for (var k in it.properties) if (k.charAt(0) !== '_' && it.properties[k]) parts.push(esc(k) + ' ×' + esc(it.properties[k]));
      if (parts.length) return plan + '<br>' + parts.join(' · ');
    }
    return plan;
  }
  function renderCart(c) {
    var box = $('#ditems'), foot = $('#dfoot');
    if (!box) return;
    setCount(c);
    if (!c.items.length) { box.innerHTML = '<div class="d-empty">Your cart is empty</div>'; foot.style.display = 'none'; return; }
    box.innerHTML = '';
    c.items.forEach(function (it, i) {
      var line = i + 1;
      var row = document.createElement('div');
      row.className = 'd-item';
      row.innerHTML = '<img src="' + esc(itemThumb(it)) + '" alt="">' +
        '<div class="d-mid"><div class="d-name">' + esc(itemName(it)) + '</div><div class="d-meta">' + itemMeta(it) + '</div>' +
        '<div class="d-quant"><button type="button" data-a="m" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-a="p" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="d-right"><button type="button" class="d-rm" title="Remove" aria-label="Remove">×</button><div class="d-price">' + fmt(it.final_line_price) + (it.selling_plan_allocation ? '/mo' : '') + '</div></div>';
      row.querySelector('[data-a="p"]').addEventListener('click', function () { change(line, it.quantity + 1); });
      row.querySelector('[data-a="m"]').addEventListener('click', function () { change(line, it.quantity - 1); });
      row.querySelector('.d-rm').addEventListener('click', function () { change(line, 0); });
      box.appendChild(row);
    });
    foot.style.display = 'block';
    $('#dsubtotal').textContent = fmt(c.total_price);
  }
  function change(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function add(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(getCart).then(function (c) { renderCart(c); openDrawer(); document.dispatchEvent(new CustomEvent('sd30:added')); return c; });
  }
  if (cartlink) cartlink.addEventListener('click', function (e) { e.preventDefault(); getCart().then(function (c) { renderCart(c); openDrawer(); }); });
  if ($('#dclose')) $('#dclose').addEventListener('click', closeDrawer);
  if ($('#overlay')) $('#overlay').addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) getCart().then(setCount); });

  /* ---------------- menu ---------------- */
  var menubtn = $('#menubtn'), menu = $('#sdmenu');
  function setMenu(open) {
    document.body.classList.toggle('menu-open', open);
    menubtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) $$('details', menu).forEach(function (d) { d.open = false; });
  }
  if (menubtn && menu) {
    menubtn.addEventListener('click', function (e) { e.stopPropagation(); setMenu(!document.body.classList.contains('menu-open')); });
    /* a tap outside an open menu only closes it, so it never lands on whatever sits underneath */
    document.addEventListener('click', function (e) { if (!document.body.classList.contains('menu-open') || menu.contains(e.target) || menubtn.contains(e.target)) return; e.preventDefault(); e.stopPropagation(); setMenu(false); }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.body.classList.contains('menu-open')) { setMenu(false); menubtn.focus(); } });
    /* About and Contact open one at a time (older browsers ignore details[name]) */
    $$('details', menu).forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) $$('details', menu).forEach(function (o) { if (o !== d) o.open = false; }); }); });
    var shop = $('.sd-menu-link', menu);
    if (shop) shop.addEventListener('click', function (e) {
      setMenu(false);
      if (shop.pathname !== location.pathname) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------------- product page ---------------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var car = $('#gcar'), dotsBox = $('.g-dots');
    var slides = $$('.g-slide', car);
    slides.forEach(function (s, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'g-dot' + (i === 0 ? ' on' : ''); d.setAttribute('aria-label', 'Image ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dotsBox.appendChild(d);
    });
    if (slides.length < 2) { $$('.g-arrow, .g-dots', pdp).forEach(function (el) { el.style.display = 'none'; }); }
    var dots = $$('.g-dot', dotsBox);
    var setDots = function (i) { dots.forEach(function (d, j) { d.classList.toggle('on', j === i); }); };
    var go = function (i) { car.scrollTo({ left: car.clientWidth * i, behavior: 'smooth' }); };
    $('.g-prev').addEventListener('click', function () { go(Math.max(0, Math.round(car.scrollLeft / car.clientWidth) - 1)); });
    $('.g-next').addEventListener('click', function () { go(Math.min(slides.length - 1, Math.round(car.scrollLeft / car.clientWidth) + 1)); });
    car.addEventListener('scroll', function () { if (car.clientWidth) setDots(Math.round(car.scrollLeft / car.clientWidth)); }, { passive: true });

    var planId = pdp.getAttribute('data-plan');
    var planMode = 'one';
    var idIn = $('#pdp-id'), planIn = $('#pdp-plan'), atc = $('#atc'), err = $('#perr');
    var pick = function (els, el) { els.forEach(function (x) { x.classList.toggle('on', x === el); }); };
    function upd() {
      var sel = $('.sizes:not(.plans) .size.on', pdp);
      if (!sel) return;
      var one = sel.getAttribute('data-price'), sub = sel.getAttribute('data-sub');
      var avail = sel.getAttribute('data-available') === 'true';
      idIn.value = sel.getAttribute('data-id');
      var p = planMode === 'one' ? one : sub + '/mo';
      var pe = $('#price'); if (pe) pe.textContent = p;
      atc.disabled = !avail;
      atc.textContent = !avail ? 'Sold out' : (planMode === 'one' ? 'Add to cart — ' : 'Subscribe — ') + p;
      var po = $('.plan-opt[data-plan="one"] small', pdp), ps = $('.plan-opt[data-plan="sub"] small', pdp);
      if (po) po.textContent = one;
      if (ps) ps.textContent = sub + '/mo · skip or cancel anytime';
      if (planIn) { planIn.disabled = planMode !== 'sub' || !planId; planIn.value = planMode === 'sub' ? planId : ''; }
    }
    var sizes = $$('.sizes:not(.plans) .size', pdp), plans = $$('.plan-opt', pdp);
    var activate = function (els, fn) {
      els.forEach(function (el) {
        el.addEventListener('click', function () { fn(el); });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(el); } });
      });
    };
    activate(sizes, function (el) { pick(sizes, el); upd(); });
    activate(plans, function (el) { pick(plans, el); planMode = el.getAttribute('data-plan'); upd(); });
    upd();
    $('#pdp-form').addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      err.hidden = true;
      var item = { id: +idIn.value, quantity: 1 };
      if (planMode === 'sub' && planId) item.selling_plan = +planId;
      atc.classList.add('busy');
      add([item]).catch(function (j) { err.textContent = (j && (j.description || j.message)) || 'Could not add to cart. Please try again.'; err.hidden = false; })
        .then(function () { atc.classList.remove('busy'); });
    });
  }

  /* ---------------- pack builder ---------------- */
  var B = $('[data-builder]');
  if (B) {
    var size = +(B.getAttribute('data-start') || 6), plan = 'one', counts = {};
    var V = { 6: B.getAttribute('data-v6'), 12: B.getAttribute('data-v12') };
    var P = { 6: +B.getAttribute('data-p6'), 12: +B.getAttribute('data-p12') };
    var PL = { 6: B.getAttribute('data-plan6'), 12: B.getAttribute('data-plan12') };
    var S = { 6: +(B.getAttribute('data-s6') || P[6]), 12: +(B.getAttribute('data-s12') || P[12]) };
    var D = { 6: B.getAttribute('data-d6'), 12: B.getAttribute('data-d12') };
    var tiles = $$('.b-tile', B), status = $('#bstatus'), cta = $('#bcta'), berr = $('#berr');
    var barinfo = $('#barinfo');
    var priceStr = function () { return plan === 'one' ? fmt(P[size]) : fmt(S[size]) + '/mo'; };
    var total = function () { var t = 0; for (var k in counts) t += counts[k]; return t; };
    function render() {
      tiles.forEach(function (el) { var c = counts[el.getAttribute('data-f')] || 0; el.querySelector('.bc').textContent = c; el.classList.toggle('sel', c > 0); });
      var t = total();
      status.textContent = t + ' / ' + size + ' selected';
      if (t === size) { cta.textContent = (plan === 'one' ? 'Add to cart — ' : 'Subscribe — ') + priceStr(); cta.classList.add('ready'); cta.disabled = false; }
      else { cta.textContent = 'Select ' + (size - t) + ' more bag' + (size - t === 1 ? '' : 's'); cta.classList.remove('ready'); cta.disabled = true; }
      if (barinfo) barinfo.textContent = t > 0 ? 'Pack ' + t + '/' + size + ' · ' + priceStr() : size + ' pack ' + priceStr() + ' · ships free';
      var bd = $('#bdesc'); if (bd && D[size]) bd.textContent = D[size];
    }
    tiles.forEach(function (el) {
      var f = el.getAttribute('data-f');
      el.querySelector('.bp').addEventListener('click', function () { if (total() < size) { counts[f] = (counts[f] || 0) + 1; render(); } });
      el.querySelector('.bm').addEventListener('click', function () { if (counts[f]) { counts[f]--; render(); } });
    });
    $$('.bt', B).forEach(function (b) {
      b.addEventListener('click', function () { size = +b.getAttribute('data-size'); $$('.bt', B).forEach(function (x) { x.classList.toggle('on', x === b); }); counts = {}; render(); });
    });
    $$('.pt', B).forEach(function (b) {
      b.addEventListener('click', function () { plan = b.getAttribute('data-plan'); $$('.pt', B).forEach(function (x) { x.classList.toggle('on', x === b); }); var n = $('#bsubnote'); if (n) n.classList.toggle('show', plan === 'sub'); render(); });
    });
    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      berr.hidden = true;
      var props = {};
      tiles.forEach(function (el) { var c = counts[el.getAttribute('data-f')]; if (c) props[el.getAttribute('data-name')] = String(c); });
      var item = { id: +V[size], quantity: 1, properties: props };
      if (plan === 'sub' && PL[size]) item.selling_plan = +PL[size];
      cta.disabled = true;
      add([item]).then(function () { counts = {}; render(); })
        .catch(function (j) { berr.textContent = (j && (j.description || j.message)) || 'Could not add to cart. Please try again.'; berr.hidden = false; render(); });
    });
    render();
    var bar = $('#thebar');
    if (bar) bar.addEventListener('click', function (e) { e.preventDefault(); B.scrollIntoView({ behavior: 'smooth' }); });
  }

  /* ---------------- deferred images ---------------- */
  /* grid photos past the first row and the creator-video posters wait until they are near the viewport, so the hero video
     gets the phone's bandwidth first; the creator posters arrive together when that section approaches */
  var later = $$('img[data-srcset]'), posters = $$('video[data-poster]');
  var fillImg = function (el) { el.srcset = el.getAttribute('data-srcset'); el.src = el.getAttribute('data-src'); el.removeAttribute('data-srcset'); el.removeAttribute('data-src'); };
  var fillPosters = function () { posters.forEach(function (v) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); }); posters = []; };
  if ('IntersectionObserver' in window) {
    var near = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (!e.isIntersecting) return; near.unobserve(e.target); if (e.target.tagName === 'IMG') fillImg(e.target); else fillPosters(); });
    }, { rootMargin: '300px 0px' });
    later.forEach(function (el) { near.observe(el); });
    if (posters.length) near.observe($('#ugc') || posters[0]);
  } else { later.forEach(fillImg); fillPosters(); }

  /* ---------------- creator videos ---------------- */
  var ucar = $('#ucar');
  if (ucar) {
    var up = $('.u-prev'), un = $('.u-next');
    if (up) up.addEventListener('click', function () { ucar.scrollBy({ left: -ucar.clientWidth * 0.8, behavior: 'smooth' }); });
    if (un) un.addEventListener('click', function () { ucar.scrollBy({ left: ucar.clientWidth * 0.8, behavior: 'smooth' }); });
    var cards = $$('.u-card', ucar);
    cards.forEach(function (c) {
      var v = $('video', c); if (!v) return;
      $('.u-thumb', c).addEventListener('click', function () {
        if (v.paused) {
          cards.forEach(function (o) { var ov = $('video', o); if (ov && ov !== v) { ov.pause(); o.classList.remove('playing'); } });
          v.muted = false; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); c.classList.add('playing');
        } else { v.pause(); c.classList.remove('playing'); }
      });
      v.addEventListener('ended', function () { c.classList.remove('playing'); });
    });
  }

  /* ---------------- hero video ---------------- */
  var hv = $('.hero-video');
  if (hv) {
    var wide = window.matchMedia('(min-aspect-ratio: 4/5)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cur = '', visible = true, blocked = false, anim = null, animUrl = '';
    var abs = function (u) { try { return new URL(u, location.href).href; } catch (e) { return u || ''; } };
    var want = function () {
      var box = hv.parentNode.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      if (wide.matches) return (box.height * 16 / 9 * dpr > 2100) ? hv.getAttribute('data-desktop-hd') : hv.getAttribute('data-desktop');
      return (box.width * dpr > 1300) ? hv.getAttribute('data-mobile-hd') : hv.getAttribute('data-mobile');
    };
    /* Low Power Mode refuses every video, so phones fall back to an animated WebP of the same loop. Its bytes carry a
       16-byte marker: Shopify's CDN otherwise hands Safari an 8 MB GIF in place of any animated WebP it recognises. */
    var dropAnim = function (fade) {
      var a = anim; anim = null; if (!a) return;
      if (fade) { a.style.opacity = '0'; setTimeout(function () { a.remove(); }, 800); } else a.remove();
    };
    var showAnim = function () {
      var src = hv.getAttribute('data-mobile-anim');
      if (anim || wide.matches || !src || still.matches) return;
      var a = anim = document.createElement('img');
      a.className = 'hero-anim'; a.alt = ''; a.setAttribute('aria-hidden', 'true'); a.decoding = 'async';
      a.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .7s ease;pointer-events:none';
      a.onload = function () { if (anim === a) a.style.opacity = '1'; };
      var show = function (url) { if (anim === a) { a.src = url; hv.parentNode.appendChild(a); } };
      if (animUrl) { show(animUrl); return; }
      (window.sdHeroAnim || fetch(src).then(function (r) { if (!r.ok) throw r; return r.arrayBuffer(); }))
        .then(function (buf) { animUrl = URL.createObjectURL(new Blob([buf.slice(16)], { type: 'image/webp' })); show(animUrl); })
        .catch(function () { if (anim === a) anim = null; });
    };
    var play = function () {
      if (!(hv.currentSrc || hv.getAttribute('src')) || !visible || document.hidden) return;
      var p = hv.play();
      if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError') { blocked = true; showAnim(); } });
    };
    /* fade the video in only once a decoded frame is on screen, so the start never flashes an empty frame over the still */
    var reveal = function () { if (hv.requestVideoFrameCallback) hv.requestVideoFrameCallback(function () { hv.classList.add('on'); }); else hv.classList.add('on'); };
    var hideNow = function () { hv.pause(); hv.style.transition = 'none'; hv.classList.remove('on'); void hv.offsetWidth; hv.style.transition = ''; };
    var off = function () { return still.matches || (navigator.connection && navigator.connection.saveData); };
    /* reduced motion or data saver: stop the autoplaying markup video and drop its download */
    var stop = function () { hv.pause(); hv.removeAttribute('autoplay'); $$('source', hv).forEach(function (s) { s.remove(); }); hv.removeAttribute('src'); hv.load(); cur = ''; };
    var load = function () {
      if (off()) return;
      var src = want(); if (!src || abs(src) === abs(cur)) return;
      if (cur) hideNow();
      cur = src; hv.muted = true; hv.src = src; hv.load(); play();
    };
    hv.addEventListener('playing', function () { reveal(); blocked = false; dropAnim(true); });
    /* a tap or click counts as permission to play, so a refused video gets another chance on the first touch */
    var unlock = function () { if (blocked) play(); };
    document.addEventListener('touchend', unlock, { passive: true });
    document.addEventListener('click', unlock);
    var onShape = function () { hideNow(); dropAnim(false); load(); if (blocked) showAnim(); };
    if (wide.addEventListener) wide.addEventListener('change', onShape); else if (wide.addListener) wide.addListener(onShape);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) play(); else hv.pause(); }).observe(hv.parentNode);
    document.addEventListener('visibilitychange', function () { if (document.hidden) hv.pause(); else play(); });
    /* the markup video is already fetching and autoplaying; adopt it, and only re-pick when the browser chose a
       source for the wrong shape (older browsers ignore <source media>) */
    if (off()) stop();
    else {
      cur = hv.currentSrc || '';
      var phoneFile = /hero-mobile/.test(cur);
      if (!cur || phoneFile === wide.matches) load();
      else if (!hv.paused) reveal();
      else play();
    }
  }
})();